import { render, staticRenderFns } from "./CleaningForm2.vue?vue&type=template&id=8f3695de"
import script from "./CleaningForm2.vue?vue&type=script&lang=js"
export * from "./CleaningForm2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports